<template>
	<div>
		<div v-if="this.isLoggedIn" class="center">

			<div class="flexcenter" style="margin-top:10px;">
				<Circle fileName="w3_reload_white" padding="20%" color="--grey-5" :spinning="this.spinning"
					@click="this.getUserModel()" style="margin-right:5px;" />
				<h3>Era uppgifter</h3>
			</div>


			<div v-if="this.company" id="company"
				style="background:var(--grey-2);padding:10px;margin-top:10px;border-radius: 5px;">



				<div class="flexcenter" style="align-items: start;gap:10px;">

					<div style="min-width:400px;flex-grow:15;">

						<div>
							<b style="font-size:120%">Företagsuppgifter</b>
						</div>

						<div style="margin-bottom:5px;margin-top:10px;">

							<b>{{ this.company.name }}</b><br />
							<b class="label">{{ this.company.number }}</b>
						</div>

						<b class="label">Telefonnummer</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Telefonnummer">
							<input type="text" placeholder="Telefonnummer" v-model="this.company.telephone"
								@keydown="this.companyEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.company.telephone = ''">
						</div>


						<b class="label">Webbsida</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Webbsida">
							<input type="text" placeholder="Webbsida, https:// " v-model="this.company.url"
								@keydown="this.companyEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.company.url = ''">
						</div>

						<b class="label">E-post (visas på vår webbsida)</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="E-post">
							<input type="text" placeholder="E-post" v-model="this.company.email"
								@keydown="this.companyEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.company.email = ''">
						</div>

						<b class="label">E-post order (visas bara för BoOve)</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="E-post order">
							<input type="text" placeholder="E-post order" v-model="this.company.emailorder"
								@keydown="this.companyEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.company.emailorder = ''">
						</div>

						<b class="label">Postadress</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Postadress">
							<input type="text" placeholder="Postadress" v-model="this.company.postaddress"
								@keydown="this.companyEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.company.postaddress = ''">
						</div>

						<div class="flexcenter">
							<div>
								<b class="label">Postnummer</b>
								<div class="form textField" style="max-width:150px;margin-bottom:10px;" title="Postnummer">
									<input type="text" placeholder="Postnummer" v-model="this.company.postnumber"
										@keydown="this.companyEdited = true" />
									<img src="@/assets/w3_button_close_light.png" @click="this.company.postnumber = ''">
								</div>
							</div>

							<div>
								<b class="label">Postort</b>
								<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Postort">
									<input type="text" placeholder="Postort" v-model="this.company.city"
										@keydown="this.companyEdited = true" />
									<img src="@/assets/w3_button_close_light.png" @click="this.company.city = ''">
								</div>
							</div>

						</div>


						<Button label="Spara" :class=" this.companyEdited ? '' : 'grey' " @click="this.updateCompany()"
							:title="'Spara uppdateringar, v:' + this.company?.version" />
					</div>

					<!-- företagets rabatter -->
					<div id="company"
						style="background:var(--grey-2);padding:0px;margin-top:0px;border-radius: 5px;flex-grow:3;max-width:400px;">
						<div style="">

							<div>
								<b style="font-size:120%">Rabatter och avtalspriser</b>
							</div>
							<div style="margin-bottom:5px;margin-top:10px;">
								<div v-for="discount in this.company?.discountList?.sort((a, b) => a.multiply - b.multiply)"
									:key="discount.discountId"
									style="background:var(--grey-4);margin-bottom:5px;padding:5px;border-radius: 5px;" class="flexcenter">
									<div
										style="background: var(--bg-discount);padding:5px;font-size:120%;color:white;border-radius: 5px;margin-right:5px;">
										{{ discount.label }}</div>
									<b>{{ discount.description }}</b>
								</div>
							</div>
						</div>
					</div>
				</div>



			</div>

			<!-- prisfiler -->
			<div v-if="this.company" id="files"
				style="background:var(--grey-2);padding:10px;margin-top:10px;border-radius: 5px;">

				<div style="margin-bottom:5px;">
					<b style="font-size:120%">Prisfiler</b>
				</div>

				<div style="background:var(--grey-3);padding:10px;border-radius: 5px;margin-bottom:10px;" class="flexcenter">
					<Circle fileName="w3_copy_white" color="--grey-5" style="margin-right:5px;" padding="20%"
						@click="this.copyUrl(this.link3)" :title="'Klicka för att kopiera adress: ' + this.link3" />
					<div style="flex-grow:1;">
						{{ this.link3}}
					</div>

					<Icon fileName="w3_chevron_right_light" style="width:15px;height:25px;" @click="this.windowOpen(this.link3)"
						:title="'Klicka för att öppna fil: ' + this.link3" />
				</div>

				<div style="background:var(--grey-3);padding:10px;border-radius: 5px;">
					<b style="font-size:100%;">{{ this.company.fileInformation }}</b>
				</div>

				<div v-if="this.webContentFileDownInformation"
					style="background:var(--grey-3);padding:10px;border-radius: 5px;margin-top:10px;">
					<div class="flexcenter link" @click="this.showFileDownInformation = !this.showFileDownInformation">
						<b style="font-size:120%;flex-grow:1;">{{ this.webContentFileDownInformation.header }}</b><br />
						<Icon :fileName="this.showFileDownInformation ? 'w3_chevron_up_light' : 'w3_chevron_down_light'"
							style="margin-right:5px;height:25px;width:25px;" />
					</div>
					<div v-if="this.showFileDownInformation" style="margin-top:10px;">
						<span v-html="this.webContentFileDownInformation.html"></span>
					</div>


				</div>

			</div>



			<!-- dina uppgifter -->
			<div v-if="this.user" id="user" style="background:var(--grey-2);padding:10px;margin-top:10px;border-radius: 5px;">

				<div style="margin-bottom:5px;">
					<b style="font-size:120%">Dina uppgifter</b>
				</div>

				<div class="flexcenter">
					<div>
						<b class="label">Förnamn</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Förnamn">
							<input type="text" placeholder="Förnamn" v-model="this.user.firstName"
								@keydown="this.userEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.user.firstName = ''">
						</div>
					</div>

					<div>
						<b class="label">Efternamn</b>
						<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Efternamn">
							<input type="text" placeholder="Efternamn" v-model="this.user.lastName"
								@keydown="this.userEdited = true" />
							<img src="@/assets/w3_button_close_light.png" @click="this.user.lastName = ''">
						</div>
					</div>
				</div>
				<div>
					<b class="label">E-post</b>
					<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="E-post">
						<input type="text" placeholder="E-post" v-model="this.user.email" @keydown="this.userEdited = true" />
						<img src="@/assets/w3_button_close_light.png" @click="this.user.email = ''">
					</div>
				</div>
				<Button label="Spara" :class="this.userEdited ? '' : 'grey'" @click="this.updateUser()" />

				<div v-if="this.user?.canDebug == true">
					<ResellerDebug />
				</div>
			</div>

			<div v-if="this.user" id="user" style="background:var(--grey-2);padding:10px;margin-top:10px;border-radius: 5px;">

				<div style="margin-bottom:5px;">
					<b style="font-size:120%">Ändra ditt lösenord</b>
				</div>


				<div>
					<b class="label">Nuvarande lösenord</b>
					<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Nuvarande lösenord">
						<input :type="this.showOldPassword ? 'text' : 'password'" ref="oldPassword" placeholder=""
							v-model="this.oldPassword" @keydown="this.passwordEdited = true" />
						<Button :label="this.showOldPassword ? 'Dölj' : 'Visa'"
							@click="this.showOldPassword = !this.showOldPassword" style="margin-right:0px;" class="grey" />
					</div>
				</div>

				<div>

					<div class="flexcenter" style="background:transparent;max-width:310px;justify-content: space-between;">
						<b class="label">Nytt lösenord</b>
						<b class="label link" @click="this.createPassword()">Förslag</b>
					</div>
					<div v-if="this.createdPassword"
						style="background: var(--grey-4);max-width:300px;padding:5px;margin-bottom:5px;border-radius: 5px;">

						<div class="flexcenter" style="justify-content: space-between;">
							<pre style="padding:5px;margin:0px;">{{ this.createdPassword }}</pre>
							<Circle fileName="w3_copy_white" padding="20%" color="--grey-6" size="20px"
								@click="this.copyToClipBoard(this.createdPassword);this.createPassword = null" />
						</div>

					</div>
					<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Nytt lösenord">
						<input :type="this.showNewPassword ? 'text' : 'password' " ref="newPassword" placeholder=""
							v-model="this.newPassword" @keydown="this.passwordEdited = true" />

						<Button :label="this.showNewPassword ? 'Dölj':'Visa' " @click="this.showNewPassword = !this.showNewPassword"
							style="margin-right:0px;" class="grey" />
					</div>
				</div>

				<div>
					<b class="label">Upprepa nytt lösenord</b>
					<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Upprepa nytt lösenord">
						<input :type="this.showNewPassword2 ? 'text' : 'password'" ref="newPassword2" placeholder=""
							v-model="this.newPassword2" @keydown="this.passwordEdited = true" />

						<Button :label="this.showNewPassword2 ? 'Dölj' : 'Visa'"
							@click="this.showNewPassword2 = !this.showNewPassword2" style="margin-right:0px;" class="grey" />
					</div>
				</div>

				<Button label="Spara" :class="this.passwordEdited ? '' : 'grey'" @click="this.updatePassword()" />


			</div>
		</div>
		<LoginRequired v-if="!this.isLoggedIn" @showSubMenuLogin="(() => { this.$emit('showSubMenuLogin') })" />
	</div>
</template>
<script>
import { STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { userMixin } from "@/mixins/userMixin.js";
import { utilMixin } from "@/mixins/utilMixin.js";
import LoginRequired from './LoginRequired.vue';
import { USER_STORE_ACTION } from '../../store/user-store';
import ResellerDebug from './ResellerDebug.vue';

export default {
	name: "ResellerInformation",
	components: { LoginRequired, ResellerDebug },
	mixins: [userMixin, utilMixin],
	props: {

	},
	data() {
		return {
			spinning: false,
			companyEdited: false,
			userEdited: false,
			passwordEdited: false,
			oldPassword: null,
			newPassword: null,
			newPassword2: null,
			createdPassword: null,
			showOldPassword: false,
			showNewPassword: false,
			showNewPassword2: false,
			showFileDownInformation: false,
			
		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		},

		baseModel() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]
		},

		company(){
			return this.userModel?.company
		},
		user() {
			return this.userModel?.user
		},
		link3(){
			return "https://public.boove.se/data/" + this.company.urlName + "/" + this.company.urlKey + "/mc/produkter/cfg3/";
		},
		link5() {
			return "https://public.boove.se/data/" + this.company.urlName + "/" + this.company.urlKey + "/mc/produkter/cfg5/";
		},
		webContentFileDownInformation(){
			return this.userModel?.webContentList?.find(webContent => webContent.name == 'FILE_DOWNLOAD_INFO');

			
		}


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		getUserModel(){
			this.spinning = true;
			this.$store.dispatch({ type: USER_STORE_ACTION.GET_USER_MODEL, data: { loginToken: this.$store.state.loginToken } }).finally(() => {
				this.spinning = false
				this.companyEdited = false
				this.userEdited = false
			});
		},

		copyUrl(url){
				navigator.clipboard.writeText(url);
				alert("Kopierade: " + url);
		},

		updateCompany(){

			if (!this.company){
				alert("Företag saknas")
			}

			if (this.company.email && !this.validateEmail(this.company.email)) {
				alert("E-posten är felaktig")
				return;
			}

			if (!this.validateEmail(this.company.emailorder)) {
				alert("E-posten för order är felaktig")
				return;
			}

			if (this.company.url && !this.company.url?.startsWith("http")) {
				alert("Urlen måste börja på http eller https")
				return;
			}

			this.spinning = true;

			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_COMPANY, data: { loginToken: this.$store.state.loginToken, company: this.company } }).finally(() => {
				this.spinning = false
				this.companyEdited = false
			});
		},
		updateUser(){

			if(!this.user){
				alert("User saknas");
			}

			if (!this.validateEmail(this.user.email)){
				alert("E-posten är felaktig")
				return;
			}

			this.spinning = true;

			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_USER, data: { loginToken: this.$store.state.loginToken, user: this.user } }).finally(() => {
				this.spinning = false
				this.userEdited = false
			});
		},

		validateEmail(email){
			
			//alert(email);
			if (!email || email == null){
				return false
			}

			if (email.length < 5){
				return false;
			}

			if (!email.includes("@")){
				return false;
			}

			if (!email.includes(".")){
				return false;
			}

			return true
		},

		updatePassword() {

			if (!this.user) {
				alert("User saknas");
			}

			if (!this.newPassword || this.newPassword.length < 6){
				alert("Ditt lösenord måste vara på minst sex tecken.")
				return;
			}

			if(this.newPassword != this.newPassword2){
				alert("Upprepa lösenordet igen");
				return;
			}

			this.spinning = true;

			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_USER_PASSWORD, data: { loginToken: this.$store.state.loginToken, oldPassword: this.oldPassword, newPassword: this.newPassword } }).then((json) => {
				if (json.status == "OK") {
					//commit("updateCompany", json.customer)
					alert("Ditt lösenord har ändrats")
					this.newPassword = null;
					this.oldPassword = null;
					this.newPassword2 = null;
					this.createdPassword = null;
				}
			} ).finally(() => {
				this.spinning = false
				this.passwordEdited = false
			});
		},

		createPassword(){

			var result = "";
			var characters = 'ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz0123456789.-$-_+.-$-_+.-$-_+.-$-_+';
			var charactersLength = characters.length;
			var length = 10;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}

			this.createdPassword = result;
		},

		windowOpen(url){
			window.open(url, '_blank')
		}


	},
	created() {

	}
};
</script>

<style scoped>

div#company b.label, div#user b.label{
	display: block;
	margin-bottom:3px;
	font-size:80%;
	color:grey;
}
</style>